'use strict';

/**
 * View for the sharing of sets in Colido Talk
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var ConversationsListView = require('modules/community/views/partials/conversations-list');

var template = require('../../templates/layout/share-with-conversation-modal.hbs');

var ShareWithConversationsModalView = LayoutView.extend({
    template: template,

    regions: {
        conversationsRegion: '.conversations-region',
    },

    ui: {
        actionClose: '[data-action="close"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
    },

    shareUrl: null,

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.conversationsListView = new ConversationsListView({
            collection: App.CommunityModule.conversationsCollection,
        });

        this.listenTo(this.conversationsListView, 'open:conversation', this.sendShareUrlToConversation.bind(this));
    },

    onRender: function() {
        this.conversationsRegion.show(this.conversationsListView);
    },

    onAttach: function() {
        this.ui.actionClose.focus();
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },

    sendShareUrlToConversation: function(conversation) {
        var message = {
            type: 'text',
            data: this.getOption('shareUrl'),
        };

        App.radio('community').execute('send:message:to:conversation', conversation, message);
    },
});

module.exports = ShareWithConversationsModalView;